import type { Messages } from '../types';

export const invite = {
  entryTitle: 'Berhubung dengan {hasName, select, true {{childName}} other {anak anda}}',
  entrySignedOutBody:
    '{hasName, select, true {{childName}} other {Anak anda}} menjemput anda ke Tupai. Guna akaun anda sendiri untuk berhubung sebagai ibu bapa mereka.',
  createAccount: 'Cipta akaun',
  haveAccount: 'Saya sudah ada akaun',
  savedNote: 'Jemputan anda disimpan semasa anda mendaftar atau log masuk.',
  entrySignedInBody:
    '{hasName, select, true {{childName}} other {Anak anda}} menjemput anda mengikuti matematik mereka di Tupai.',
  loggedInAs: 'Log masuk sebagai',
  switchAccount: 'Tukar',
  continueCta: 'Teruskan',
  checking: 'Menyemak…',

  fullTitle: 'Pelan anda sudah penuh',
  fullBody:
    '{hasPlan, select, true {{planName} meliputi {seats} anak, dan tempat itu sudah diambil. Tukar pelan anda untuk menghubungkan {hasName, select, true {{childName}} other {anak anda}}.} other {Pelan anda tiada tempat kosong lagi. Tukar pelan anda untuk menghubungkan {hasName, select, true {{childName}} other {anak anda}}.}}',
  freeFullTitle: 'Pelan Percuma anda sudah ada 1 anak',
  freeFullBody:
    'Percuma meliputi 1 anak. {hasName, select, true {{childName}} other {Anak anda}} tidak boleh dihubungkan pada pelan ini.',
  freePlanLabel: 'Pelan Percuma',
  freeUpgradeNote: 'Family Solo masih meliputi 1 anak. Family Duo menambah anak kedua.',
  freeUpgradeCta: 'Naik taraf ke Family Duo',
  freeNotLinked: '{hasName, select, true {{childName}} other {Anak anda}} belum berhubung',
  freeCurrentStays: 'Anak semasa anda kekal berhubung.',
  syllabusTitle: 'Pelan anda tidak meliputi sukatan ini',
  syllabusBody:
    '{hasName, select, true {{childName}} other {Anak anda}} belajar sukatan yang bukan sebahagian daripada pelan anda. Tukar pelan anda untuk menghubungkan {hasName, select, true {{childName}} other {anak anda}}.',
  keptTitle: 'Jemputan anda disimpan',
  keptBody: 'Anda boleh kembali ke pautan ini dalam tempoh 24 jam.',

  alreadyLinkedTitle: '{hasName, select, true {{childName}} other {Anak anda}} sudah berhubung',
  alreadyLinkedBody:
    '{hasName, select, true {{childName}} other {Anak anda}} sudah berhubung dengan akaun ini. Tiada apa lagi yang perlu dibuat.',
  goToChildren: 'Pergi ke Anak saya',
  takenTitle: 'Anak ini sudah berhubung',
  expiredTitle: 'Pautan ini telah tamat tempoh',
  expiredBody:
    'Pautan jemputan sah selama 24 jam. Minta anak anda hantar yang baharu dari Tupai Pelajar.',
  invalidTitle: 'Pautan ini tidak berfungsi',
  invalidBody:
    'Mungkin ia sudah digunakan atau tersalin dengan salah. Minta anak anda hantar yang baharu.',
  openParent: 'Buka Tupai Ibu Bapa',
  errorTitle: 'Kami tidak dapat menghubungkan sekarang',
  errorBody: 'Semak sambungan anda dan cuba lagi.',
  tryAgain: 'Cuba lagi',

  laterTitle: 'Tiada persetujuan diberi',
  laterBody:
    '{hasName, select, true {{childName}} other {Anak anda}} belum berhubung. {isUnder13, select, true {Anak bawah 13 tahun juga tidak dapat menamatkan pendaftaran. } other {}}Pautan ini masih sah selama 24 jam.',
  giveConsentNow: 'Beri persetujuan sekarang',
  close: 'Tutup',

  allSetTitle: 'Siap',
  allSetBody:
    '{hasName, select, true {{childName}} other {Anak anda}} sudah berhubung dengan akaun anda.',
  handBackTitle:
    'Serahkan telefon kembali kepada {hasName, select, true {{childName}} other {anak anda}}',
  handBackBody:
    'Anda telah log keluar dari telefon ini. Buka Tupai Ibu Bapa pada telefon anda sendiri untuk mengikuti {hasName, select, true {{childName}} other {anak anda}}.',
  handBackSavedBody:
    '{hasName, select, true {{childName}} other {Anak anda}} belum berhubung. Anda telah log keluar dari telefon ini. Buka pautan ini pada telefon anda sendiri dalam tempoh 24 jam untuk berhubung.',
  handBackEndedBody: 'Anda telah log keluar dari telefon ini.',
} as const satisfies Messages['invite'];
